// import { Guidance } from '../../../core/guidance/Guidance';
import * as React from 'react';
import style from '../style/WForm.less';
import { i18n } from '../../../i18n/i18n';

interface WFormFieldSelectOptAsSliderProps extends React.ClassAttributes<any> {
    value: any;
    name?: string;
    entity?: string;
    options: any[];
    label: string | JSX.Element;
    disabled?: boolean;
    horizontal?: boolean;
    layout?: string;
    helpKey?: string;
    asJaNein?: boolean;
    customStyle?: any;
    onChange(evt: any): void;
}

/************************************************
 *  ACHTUNG
 *  Dieser Slider ist nur für die Ja-Nein-Auswahl gemacht, d.h. Ja = value = 1 und Nein = value = 2
 ********************************************/

export class WFormFieldSelectOptAsSlider extends React.Component<WFormFieldSelectOptAsSliderProps, {}> {

    constructor(props: any) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(evt: any): void {
        const { options } = this.props;
        const checked: boolean = evt.target.checked;
        let opt: any
        if (this.props.asJaNein) {
            // opt = options.find((o: any) => (o.value + '').toLowerCase() === (checked ? 'ja' : 'nein') || (o.label + '').toLowerCase() === (checked ? 'ja' : 'nein'));
            opt = options.find((o: any) => (o.value + '').toLowerCase() === (checked ? 'ja' : 'nein')
                || (o.label + '').toLowerCase() === (checked ? i18n('Ja', 'sys').toLowerCase() : i18n('Nein', 'sys').toLowerCase()));
        } else {
            opt = options.find((o: any) => o.value === (checked ? 1 : 2));
        }
        if (opt) {
            this.props.onChange(opt);
        }
    }

    render(): JSX.Element {
        const { disabled } = this.props;

        let checked: boolean;
        if (this.props.asJaNein) {
            // checked = ((this.props.value || {}).value + '').toLowerCase() === 'ja' || ((this.props.value || {}).label + '').toLowerCase() === 'ja';
            checked = ((this.props.value || {}).value + '').toLowerCase() === 'ja'
                || ((this.props.value || {}).label + '').toLowerCase() === i18n('Ja', 'sys').toLowerCase();
        } else {
            checked = (this.props.value || {}).value === 1;
        }

        const flex: React.CSSProperties = this.props.horizontal ? { display: 'flex', flexDirection: 'row' } : {};
        return (
            <div
                style={{
                    ...flex, width: 'auto',
                    ...this.props.customStyle || {}
                }}>
                <div
                    style={{ paddingTop: 6 }}
                    onMouseOver={() => {
                        if (this.props.helpKey || this.props.name) {
                            // console.log(`Focus on "${this.props.name}"`);
                            // console.log(`Focus on "${this.props.helpKey || this.props.name}"`);
                            // Guidance.instance?.setFieldAndEntity(this.props.name, this.props.entity);
                            // if (this.props.helpKey) {
                            //     Guidance.instance?.setFieldAndEntity(this.props.helpKey, null);
                            // } else {
                            //     Guidance.instance?.setFieldAndEntity(this.props.name, this.props.entity);
                            // }
                        }
                    }}
                >
                    <label
                        className={style.toggleCheckboxWrapper}
                        style={{ marginRight: 10, marginLeft: 0 }}
                    >
                        <input
                            className={style.toggleInput}
                            type='checkbox'
                            disabled={disabled}
                            checked={checked}
                            onChange={this.onChange}
                            onFocus={() => {
                                // console.log(`Focus on "${this.props.name}"`);
                                // console.log(`Focus on "${this.props.helpKey || this.props.name}"`);
                                // Guidance.instance?.setFieldAndEntity(this.props.name, this.props.entity);
                                // if (this.props.helpKey) {
                                //     Guidance.instance?.setFieldAndEntity(this.props.helpKey, null);
                                // } else {
                                //     Guidance.instance?.setFieldAndEntity(this.props.name, this.props.entity);
                                // }
                            }}
                        // onBlur={() => Guidance.instance?.setFieldAndEntity(null, null) }
                        />
                        <span className={checked ? style.toggleSlider : style.toggleSliderOff}></span>
                    </label>
                </div>
                {this.props.label}
            </div>
        );
    }
}
